import type { CmmdBoardTask, CmmdTaskWorkflow } from "@cmmd-forge/contracts";
import { getStatusConfig } from "~/components/command-center/statusConfig";
import type { ProjectTaskPickerOption } from "./ProjectTaskPicker";
import { INTERRUPTED_TASK_STATUSES } from "./taskWorkflowGroups";
import { TASK_STATUS_OPTIONS } from "./taskViewTypes";

export function projectTaskStatusOptions(
  task: CmmdBoardTask,
  workflow: CmmdTaskWorkflow | null,
): readonly ProjectTaskPickerOption[] {
  if (workflow) {
    const sourceStageId = task.workflowStageId ?? task.workflowResumeStageId;
    const needsFallbackStatus =
      sourceStageId == null &&
      !INTERRUPTED_TASK_STATUSES.some((interruptedStatus) => interruptedStatus === task.status);
    const allowedStageIds = new Set(
      sourceStageId == null
        ? workflow.stages.map((stage) => stage.id)
        : [
            sourceStageId,
            ...workflow.transitions
              .filter((transition) => transition.fromStageId === sourceStageId)
              .map((transition) => transition.toStageId),
          ],
    );
    return [
      ...(needsFallbackStatus
        ? [
            {
              value: task.status,
              label: getStatusConfig(task.status).label,
              visual: {
                kind: "status" as const,
                colorClass: getStatusConfig(task.status).dotColor,
              },
            },
          ]
        : []),
      ...workflow.stages
        .filter((stage) => allowedStageIds.has(stage.id))
        .map<ProjectTaskPickerOption>((stage) => ({
          value: stage.id,
          label: stage.name,
          visual: { kind: "workflowStage", color: stage.color },
        })),
      ...INTERRUPTED_TASK_STATUSES.map<ProjectTaskPickerOption>((status) => ({
        value: status,
        label: getStatusConfig(status).label,
        visual: { kind: "status", colorClass: getStatusConfig(status).dotColor },
      })),
    ];
  }
  return TASK_STATUS_OPTIONS.map<ProjectTaskPickerOption>((status) => ({
    value: status,
    label: getStatusConfig(status).label,
    visual: { kind: "status", colorClass: getStatusConfig(status).dotColor },
  }));
}
